<template>
    <el-dialog
        :title="$t('selectShop')"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="dialogClose"
        center
        top="5vh"
        custom-class="large-dialog">
        <div class="content">
            <div class="search">
                <div class="search-item">
                    <span class="name">mid</span>
                    <el-input v-model="search.id" placeholder="mid" size="mini" clearable @change="searchHandle"></el-input>
                </div>
                <div class="search-item">
                    <span class="name">{{$t('name')}}</span>
                    <el-input v-model="search.name" :placeholder="$t('name')" size="mini" clearable @change="searchHandle"></el-input>
                </div>
                <div class="search-handle">
                    <el-button type="primary" size="mini" @click="searchHandle">{{$t('search')}}</el-button>
                    <el-button type="primary" size="mini" @click="emptySearchHandle">{{$t('empty')}}</el-button>
                </div>
            </div>
            <el-table :data="tableData" border style="width: 100%" max-height="480">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column :label="$t('shopBasicInfo')" align="left" min-width="260">
                    <template slot-scope="scope">
                        <div class="info">
                            <el-image :src="scope.row.logoUrl" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img src="../../assets/images/default.png"/>
                                </div>
                            </el-image>
                            <div class="desc base-desc">
                                <div class="tag">
                                    <el-tag type="success" size="medium" v-if="scope.row.type == 101">{{ scope.row.id }}</el-tag>
                                    <el-tag type="danger" size="medium" v-if="scope.row.type == 102">{{ scope.row.id }}</el-tag>
                                    <el-tag type="warning" size="medium" v-if="scope.row.type == 103">{{ scope.row.id }}</el-tag>
                                </div>
                                <p class="desc-item">{{ scope.row.name }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('mercBasicInfo')" align="left" min-width="260">
                    <template slot-scope="scope">
                        <div class="info">
                            <div class="desc" v-if="scope.row.company">
                                <p class="desc-item">
                                    {{scope.row.company.firstName}} {{scope.row.company.lastName}}
                                </p>
                                <p class="desc-item">
                                    {{scope.row.company.name}}
                                </p>
                                <p class="desc-item">
                                    {{scope.row.company.vatNumber}}&nbsp;&nbsp;{{scope.row.company.taxCode}}
                                </p>
                                <p class="desc-item">
                                    <span>{{scope.row.company.address}} {{scope.row.company.houseNumber}}</span>
                                    <span v-if="scope.row.company.city">-{{scope.row.company.city}}</span>
                                    <span v-if="scope.row.company.province">-{{scope.row.company.province.name}}</span>
                                    <span v-if="scope.row.company.country">-{{scope.row.company.country.name}}</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" :label="$t('addressInfo')" align="left" min-width="260">
                    <template slot-scope="scope">
                        <div class="info" >
                            <div class="desc" v-if="scope.row.address">
                                <p class="desc-item">
                                    {{scope.row.address.address}}
                                </p>
                                <p class="desc-item">
                                    <span v-if="scope.row.address.city">{{scope.row.address.city}}</span>
                                    <span v-if="scope.row.address.province">-{{scope.row.address.province.name}}</span>
                                    <span v-if="scope.row.address.country">-{{scope.row.address.country.name}}</span>
                                    <span v-if="scope.row.address.zipcode">-{{scope.row.address.zipcode}}</span>
                                </p>
                                <p class="desc-item">{{scope.row.address.contactName}} {{scope.row.address.contactPhone}} {{scope.row.address.contactEmail}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="120" :label="$t('handle')">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   size="small"
                                   @click="selectHandle(scope.row)">
                            {{ $t('select') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="currentPage"
                    layout="sizes, prev, pager, next, total"
                    :page-sizes="[10, 15, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ $t('close') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>

import {queryPointsMeShop} from "@/api/modules/api";

export default {
    name: "PointsMeShop",
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            search: {
                id: '',
                name: '',
            },
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0
        };
    },
    // 计算属性
    computed: {},
    filters: {
    
    },
    // 监控data中的数据变化
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    // 方法集合
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.emptySearchHandle()
        },
        // 查询列表
        getListData () {
            let params = {
                id: this.search.id,
                name: this.search.name,
                page: this.currentPage,
                size: this.pageSize
            }
            queryPointsMeShop(params).then(res => {
                if (res.code === 20000) {
                    this.total = res.data.total
                    this.tableData = res.data.list || []
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        
        // 搜索
        searchHandle () {
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptySearchHandle () {
            this.search = {
                id: '',
                name: '',
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 点击分页
        handleCurrentChange (page) {
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        
        // 提交
        selectHandle (data) {
            this.dialogVisible = false
            this.$emit('parent-update', data)
        },
        // 关闭弹窗
        dialogClose () {
            this.$emit('parent-close')
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
    
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/table-dialog.scss';
</style>
